/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='loader'>
        <Sprite position={[1414, 1514]} name='bar'>
            <Image src='loading_bar_empty' />
            <Sprite mask={[0, 0, 500, 156]} name='fill'>
                <Image src='loading_bar_full' />
                <Image position={[-46, 28]} name='cover' src='loading_bar_cover' />
                <Sprite position={[14, 0]} name='startPoint' />
                <Sprite position={[910, 0]} name='endPoint' />
            </Sprite>
            <Image src='loading_bar_frame' />
        </Sprite>
        <Button position={[1619, 1514]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='startButton'>
            <Sprite>
                <Image src='preloader_button_normal' />
                <Text
                    position={[301, 110]}
                    anchor={[0.5, 0.5]}
                    style={{
                        fontFamily: 'PF DinDisplay Pro',
                        fontSize: 85,
                        fontStyle: 'normal',
                        fill: '#FFFFFF',
                        align: 'center',
                        fontWeight: 'bold'
                    }}
                    maxWidth={400}
                    name='title'
                    localeTextID='buttonStart'
                    text='START'
                />
            </Sprite>
            <Sprite>
                <Image src='preloader_button_focused' />
                <Text
                    position={[301, 110]}
                    anchor={[0.5, 0.5]}
                    style={{
                        fontFamily: 'PF DinDisplay Pro',
                        fontSize: 85,
                        fontStyle: 'normal',
                        fill: '#FFFFFF',
                        align: 'center',
                        fontWeight: 'bold'
                    }}
                    maxWidth={400}
                    name='title'
                    localeTextID='buttonStart'
                    text='START'
                />
            </Sprite>
            <Sprite>
                <Image src='preloader_button_pressed' />
                <Text
                    position={[301, 110]}
                    anchor={[0.5, 0.5]}
                    style={{
                        fontFamily: 'PF DinDisplay Pro',
                        fontSize: 75,
                        fontStyle: 'normal',
                        fill: '#FFFFFF',
                        align: 'center',
                        fontWeight: 'bold'
                    }}
                    maxWidth={375}
                    name='title'
                    localeTextID='buttonStart'
                    text=''
                />
            </Sprite>
            <Sprite />
        </Button>
        <Button position={[2786, 822]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='nextButton'>
            <Sprite>
                <Image src='preloader_next_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_focused' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[922, 822]} hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} flipH={true} name='previousButton'>
            <Sprite>
                <Image src='preloader_next_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_focused' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='preloader_next_button_disabled' />
            </Sprite>
        </Button>
        <Sprite position={[0, 1375]} name='dots' />
    </Sprite>
);
